import { useTranslation } from 'react-i18next'
import { ReportChart } from '@/components/relatorios/ReportChart'
import { ReportKpiCard } from '@/components/relatorios/ReportKpiCard'
import { ReportShell } from '@/components/relatorios/ReportShell'
import { ReportTable } from '@/components/relatorios/ReportTable'
import { exportCsv } from '@/components/relatorios/reportUtils'
import { useLeadEntryReport } from '@/hooks/reports/reportHooks'
import { useReportDateRange } from '@/hooks/reports/useReportDateRange'
import { formatDayKey } from '@/lib/accountTimezone'
import { formatDecimal, formatNumber } from '@/lib/dashboardFormat'

export default function EntradaLeadsReport() {
  const { t } = useTranslation('reports')
  const [range, setRange] = useReportDateRange()
  const report = useLeadEntryReport(range)
  const total = report.data.reduce((sum, row) => sum + row.leads, 0)
  const chartRows = report.data.map((row) => ({
    ...row,
    label: formatDayKey(row.date, { day: '2-digit', month: '2-digit' }),
  }))

  return (
    <ReportShell
      title={t('leadEntry.title')}
      description={t('leadEntry.description')}
      {...range}
      onRangeChange={setRange}
      loading={report.loading}
      error={report.error}
      empty={!report.data.some((row) => row.leads > 0)}
      onRetry={report.refetch}
      onExport={() => exportCsv('entrada-leads', report.data, [
        { label: t('fields.date'), value: (row) => row.date },
        { label: t('fields.leads'), value: (row) => row.leads },
      ])}
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <ReportKpiCard label={t('leadEntry.kpiTotal')} value={formatNumber(total)} />
        <ReportKpiCard label={t('leadEntry.kpiDailyAverage')} value={formatDecimal(total / Math.max(report.data.length, 1))} />
      </div>
      <ReportChart
        data={chartRows}
        xKey="label"
        series={[{ key: 'leads', label: t('fields.leads'), color: 'var(--primary)' }]}
      />
      <ReportTable
        rows={report.data}
        rowKey={(row) => row.date}
        columns={[
          { key: 'date', label: t('fields.date'), render: (row) => formatDayKey(row.date) },
          { key: 'leads', label: t('fields.leads'), align: 'right', render: (row) => formatNumber(row.leads) },
        ]}
      />
    </ReportShell>
  )
}
